import { Box } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemedLoadingAnimation } from './themed';

export const PageLoadingFallback = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
    }}
  >
    <AnimatePresence>
      <motion.div
        key="page-loading-fallback"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2, delay: 0.1 }}
      >
        <ThemedLoadingAnimation message="Loading..." />
      </motion.div>
    </AnimatePresence>
  </Box>
);
